export class ActivateUser {
    email: string;
    token: string;
    password: string;
}